export const SalesOrderIcon = () => (
    <svg viewBox="0 0 24 24" fill="none">
        <path
            d="M14 2H6C4.9 2 4 2.9 4 4v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
            fill="#000000"
        />
        <path
            d="M8 12h5m0 0l-2-2m2 2l-2 2"
            stroke="#000000"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 16h8"
            stroke="#000000"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);